.header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 0.5rem;
  padding-bottom: 0.5rem;
  border-bottom: 1px solid #e0e0e0;
}

.headerTitle {
  font-size: 1.25rem;
  font-weight: 600;
  margin: 0;
}

.infoRow {
  display: flex;
  gap: 1rem;
  margin-bottom: 0.5rem;
  flex-wrap: wrap;
}

.infoItem {
  flex: 1;
  min-width: 200px;
}

.infoLabel {
  font-weight: 600;
  display: inline;
  margin-right: 0.5rem;
}

.infoValue {
  display: inline;
}

.divider {
  height: 1px;
  background-color: #e0e0e0;
  margin: 0.5rem 0;
}

.equipmentDetails {
  background-color: #f5f5f5;
  padding: 0.75rem;
  border-radius: 4px;
  margin: 0.25rem 0;
}

.detailItem {
  margin-bottom: 0.35rem;
}

.detailLabel {
  font-weight: 600;
  display: inline;
  margin-right: 0.5rem;
}

.detailValue {
  display: inline;
}
